import React, { useState, useEffect, useRef, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import moment from "moment";
import { sbaAxios } from "../../../utils/sbaAxios";
import { generateCSBatch, getCSBatch, getCSByBatch, getCSFamily, getCSFrequency, getCSOwner } from "../../../../config/apiConfig";
import { SBNotify } from "../../../utils/sbNotify";

const date = new Date();
const reportDate = new Date(date.getFullYear(), date.getMonth(), 0);

export const Batch = ({statementDate,setStatementDate}) => {
    // const [statementDate, setStatementDate] = useState(reportDate);
    const [batchDs, setBatchDS] = useState([]);
    const [familyDs, setFamilyDS] = useState([]);
    const [ownerDs, setOwnerDS] = useState([]);
    const [frequencyDs, setFrequencyDS] = useState([]);
    const [selectedBatch, setSelectedBatch] = useState(null);
    const [selectedFamily, setSelectedFamily] = useState(null);
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [selectedFrequency, setSelectedFrequency] = useState(null);
    const [CSData, setCSData] = useState([]);
    const ref = useRef();
    const isInitialLoad = useRef(true);
    useEffect(()=>{
        if (!isInitialLoad.current)
        getCSData();
    },[selectedFrequency,selectedOwner,statementDate,selectedFamily,selectedBatch])
    useEffect(() => {
        if (isInitialLoad.current) {
        getBatch();
        getFamilyList();
        getOwnerList();
        getFrequency();
        getCSData();
            isInitialLoad.current = false;         
    }
    document.title = `Client Statements`;
    }, []);
    

    const fetchData = async (url, setter) => {
        try {
            const result = await sbaAxios({ url });
            setter(result);
        } catch (error) {
            setter([]);
        }
    };

    const getBatch = useCallback(() => fetchData(getCSBatch, setBatchDS), []);
    const getFamilyList = useCallback(() => fetchData(getCSFamily, setFamilyDS), []);
    const getOwnerList = useCallback(() => fetchData(getCSOwner, setOwnerDS), []);
    const getFrequency = useCallback(() => fetchData(getCSFrequency, setFrequencyDS), []);

    const getCSData = useCallback(async () => {
        try {
            let url = `${getCSByBatch}?reportDate=${statementDate.toISOString()}`;

            if (selectedBatch?.EnumValue) {
                url += `&batchNumId=${selectedBatch.EnumValue}`;
            }
            if (selectedFamily?.FamilyId) {
                url += `&familyId=${selectedFamily.FamilyId}`;
            }
            if (selectedOwner?.UserId) {
                url += `&userId=${selectedOwner.UserId}`;
            }
            if (selectedFrequency?.EnumValue) {
                url += `&reportingFrequencyId=${selectedFrequency.EnumValue}`;
            }

            const result = await sbaAxios({ url });
            setCSData(result);
        } catch (error) {
            setCSData([]);
        }
    }, [statementDate, selectedBatch, selectedFamily, selectedOwner, selectedFrequency]);

    const updateState = (e, setter) => {
        setter(e.value || null);
    };

    const gridColDef = [
        { headerName: "Client Statement", field: "ClientStatementName", filter: "agTextColumnFilter" },
        { field: '', headerCheckboxSelection: true, checkboxSelection: true, showDisabledCheckboxes: true, maxWidth: 80 }
    ];

    const generateCS = useCallback(async () => {
        try {
            const selectedRows = ref?.current?.api?.getSelectedRows();
            const clientStatementIds = selectedRows?.map(item => item.ClientStatementId);
            const data = {
                "reportDate": statementDate.toISOString(),
                "clientStatementIdList": clientStatementIds
            };
            if (clientStatementIds.length > 0) {
                const result = await sbaAxios({ url: generateCSBatch, method: 'post', data: data });
                SBNotify({ Msg: "Reports Generated Successfully" });
            } else {
                SBNotify({ Msg: "Please Select Any Client Statement", type: 'error' });
            }
        } catch (error) {
            SBNotify({ Msg: "Error Occurred While Generating the Report", type: "error" });
        }
    }, [statementDate]);

    return (
        <>
            <div className="row">
                <div className="col-md-2 d-flex">
                    <div>
                        <span className="fw-medium d-block">Report Date</span>
                        <SBDatePicker className="form-control" value={moment(statementDate)} onChange={(e) => setStatementDate(new Date(e))} />
                    </div>
                </div>
                <div className="col-md-2 d-flex">
                    <div>
                        <span className="fw-medium d-block">Report Batch</span>
                        <SBAComboBox data={batchDs} textField="EnumName" valueField="EnumValue" value={selectedBatch} placeholder="All" filterable onChange={(e) => updateState(e, setSelectedBatch)} />
                    </div>
                </div>
                <div className="col-md-2 d-flex">
                    <div>
                        <span className="fw-medium d-block">Family</span>
                        <SBAComboBox data={familyDs} textField="FamilyName" valueField="FamilyId" value={selectedFamily} placeholder="All" filterable onChange={(e) => updateState(e, setSelectedFamily)} />
                    </div>
                </div>
                <div className="col-md-2 d-flex">
                    <div>
                        <span className="fw-medium d-block">Owner</span>
                        <SBAComboBox data={ownerDs} textField="Fullname" valueField="UserId" value={selectedOwner} placeholder="All" filterable onChange={(e) => updateState(e, setSelectedOwner)} />
                    </div>
                </div>
                <div className="col-md-2 d-flex">
                    <div>
                        <span className="fw-medium d-block">Report Frequency</span>
                        <SBAComboBox data={frequencyDs} textField="EnumName" valueField="EnumValue" value={selectedFrequency} placeholder="All" filterable onChange={(e) => updateState(e, setSelectedFrequency)} />
                    </div>
                </div>
                <div className="col-md-2 d-flex row-items justify-content-end">
                    <button className="p-sm-btn mx-1" onClick={()=>{generateCS()}}>Generate</button>
                </div>
            </div>
            <div className="ag-theme-alpine m-1 w-50" style={{ minHeight: '100px', height: '70vh' }}>
                <AgGridReact
                    columnDefs={gridColDef}
                    rowData={CSData}
                    ref={ref}
                    defaultColDef={{ flex: 1 , floatingFilter:true,resizable:true }}
                    suppressScrollOnNewData
                    rowSelection="multiple"
                    isRowSelectable={(params) => {
                        return !(params.data.ClientStatementStatusTypeId === 3);
                    }}
                />
            </div>
        </>
    );
};
